// THE search-text normalizer — lowercase + strip combining diacritics so
// "Curl français" matches "francais". Extracted from the two byte-identical
// inline copies (ExercisePicker, catalogSections) when the Library browser
// became the third caller (HR-S3c).
export const normalizeSearch = (s: string): string =>
  s.toLowerCase().normalize("NFKD").replace(/[̀-ͯ]/g, "");
